import { Component, computed, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { switchMap } from 'rxjs/operators';
import { OrdersService } from '../orders.service';
import { PhotoPreview } from '../photo-preview/photo-preview';
import { DownloadService } from '../download.service';
import { OrderLocationComponent } from '../order-location/order-location.component';
import { OrderDeletedComponent } from '../order-deleted/order-deleted.component';
import { OrderPropertiesComponent } from "../order-properties/order-properties.component";
import { Location } from '@angular/common';
import { OrderDeviceComponent } from "../order-device/order-device.component";
import { StatusSelectComponent } from "../status-select/status-select.component";
import { IconComponent } from "../../../shared/icon/icon.component";

@Component({
  selector: 'app-order-details',
  standalone: true,
  imports: [PhotoPreview, CommonModule, OrderLocationComponent, OrderDeletedComponent, OrderPropertiesComponent, OrderDeviceComponent, StatusSelectComponent, IconComponent],
  templateUrl: './order-details.component.html',
  styleUrl: './order-details.component.css'
})
export class OrderDetailsComponent {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  public ordersService = inject(OrdersService);
  private downloadService = inject(DownloadService);
  private location = inject(Location);

  // Get order based on route parameter
  order = toSignal(
    this.route.paramMap.pipe(
      switchMap(params => {
        const orderId = params.get('id');
        console.log('OrderDetailsComponent: Route param id =', orderId);
        
        if (!orderId) {
          console.error('No order ID provided');
          this.router.navigate(['/orders']);
          throw new Error('No order ID provided');
        }
        
        console.log('Fetching order with ID:', orderId);
        return this.ordersService.getOrder(orderId);
      })
    )
  );

  constructor() {
    console.log('OrderDetailsComponent constructor called');
  }

  ngOnInit() {
    console.log('OrderDetailsComponent ngOnInit called');
    console.log('Current order:', this.order());
  }

  // Change from computed to a writable signal
  downloading = signal(false);

  goBack() {
    this.location.back();
  }

  onStatusChange(newStatus: string) {
    const currentOrder = this.order();

    if (currentOrder) {
      this.ordersService.updateOrderStatus(currentOrder.id, newStatus);
    }
  }

  // Make this method async
  async downloadPhotos() {
    const currentOrder = this.order();
    if (currentOrder && !this.downloading()) {
      try {
        // Set downloading to true at the start
        this.downloading.set(true);
        
        // Change status to "processing" before downloading
        await this.ordersService.updateOrderStatus(currentOrder.id, 'processing');
        
        // Download photos - await this to ensure we don't reset downloading too early
        await this.downloadService.downloadOrderPhotos(currentOrder);
        
      } catch (error) {
        console.error('Error downloading photos:', error);
        alert('Failed to download photos. Please try again.');
      } finally {
        // Always set downloading back to false when done
        this.downloading.set(false);
      }
    }
  }

  photos = computed(() => {
    const currentOrder = this.order();
    return currentOrder ? Object.values(currentOrder.photos) : [];
  });
}
